import Box from '@mui/system/Box';
import Container from '@mui/material/Container';
import '../CSS/Estilo.css';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';

export default function MenuGestionFicheros({estiloPagina,onClick})
{
    const estiloIcono={
        fontSize:'1.2em',
        ml:'15px'
      }

    return(
        <Box>
            <Container sx={{display:'flex'}}>
                <label style={{color:estiloPagina.color}} className='rotuloMediano'>Menú</label>
            </Container>    
            <Box id={'DivButtons'} onClick={onClick}>
                <button id={"btFileUpload"} className="btMenuBlue">
                        <Box id='box' sx={{display:'inline-flex',alignContent:'center'}}>
                            Subir ficheros
                            <CloudUploadIcon sx={estiloIcono}></CloudUploadIcon>
                        </Box>
                    </button>
                <button id={"btDirectoryUpload"} className="btMenuBlue">
                    <Box id='box' sx={{display:'inline-flex',alignContent:'center'}}>
                        Subir directorios
                        <DriveFolderUploadIcon sx={estiloIcono}></DriveFolderUploadIcon>
                    </Box>
                </button>
            </Box>                
        </Box>
    )
}